import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/queryClient";
import { ThemeProvider } from "./context/ThemeContext";
import { ThemeMetaSync } from "./components/base/ThemeMetaSync";
import { BrowserRouter } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import routes from "./router/config";
import { AlertProvider } from "./context/AlertContext";
import { useEffect } from "react";
import { onMessageListener, listenForSwNavigation, listenForSessionClosedSignal } from "./firebaseMessaging";
import { CustomNotification } from "./components/base/PushNotification";
import { ToastContainer } from "react-toastify";
import { AnalyticsProvider } from "./components/analytics/AnalyticsProvider";
import { useUserStore } from "./store/userStore";
import AvisosLoginModal from "./components/base/AvisosLoginModal";
import { forceRemoteLogout } from "./utils/tokenUtils";
import "react-toastify/dist/ReactToastify.css";
import TitleTooltips from "./components/ui/TitleTooltips";
import VehicleGarageHost from "./components/vehicles/VehicleGarage";
import AppTransitionOverlay from "./components/ui/AppTransitionOverlay";


function AppRoutes() {
  return useRoutes(routes);
}

function App() {
  const loadUserFromStorage = useUserStore((state) => state.loadUserFromStorage);
  
  useEffect(() => {
    // Cargar usuario persistido al iniciar la aplicación
    loadUserFromStorage();

    // Configurar listener para notificaciones push
    onMessageListener((props) => <CustomNotification {...props} />);

    // Configurar listeners para cierre remoto de sesiones
    listenForSwNavigation();
    listenForSessionClosedSignal();

    // Listener de BroadcastChannel para sincronizar logout entre pestañas
    try {
      const authChannel = new BroadcastChannel("auth");
      authChannel.addEventListener("message", (event) => {
        if (event.data?.type === "session_closed") {
          // Otra pestaña/dispositivo se deslogueó
          forceRemoteLogout("Sesión cerrada", "Iniciaste sesión en otro dispositivo o tu sesión fue cerrada.");
        }
      });
      return () => authChannel.close();
    } catch (error) {
      console.warn("BroadcastChannel not available:", error);
    }
  }, [loadUserFromStorage]);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <ThemeMetaSync />
        <BrowserRouter>
          <AnalyticsProvider>
            <AlertProvider>
              <ToastContainer />
              <TitleTooltips />
              <VehicleGarageHost />
              <AppTransitionOverlay />
              <AppRoutes />
              <AvisosLoginModal />
            </AlertProvider>
          </AnalyticsProvider>
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
